<template>
  <div class="enterprise-con">
    <common-header style="background: #fff ;"></common-header>
    <div class="content">
      <!--第一步 登录/注册 -->
      <Login v-if="islogin" @nextSub="loginNext"></Login>
      <!-- 实名步骤 -->
      <div class="enterprise-step" v-else>
        <!-- 步骤条 -->
        <div class="step-line">
           <div class="step-line-item">
            <img src="../../assets/images/enterpriseAuth/step1.png" alt="" v-show="stepCur == 1"/>
            <img src="../../assets/images/enterpriseAuth/step2.png" alt="" v-show="stepCur == 2"/>
            <img src="../../assets/images/enterpriseAuth/step3.png" alt="" v-show="stepCur == 3"/>
            <img src="../../assets/images/enterpriseAuth/step4.png" alt="" v-show="stepCur == 4"/>
          </div>
          <div class="step-line-text">
            <span>个人信息</span>
            <span>人脸识别</span>
            <span>机构信息</span>
            <span>审核结果</span>
          </div>
        </div>
        <!-- 个人信息 -->
        <div class="personal-auth" v-if="stepCur == 1">
          <div class="auth-title">
            <img alt="" src="../../assets/images/enterpriseAuth/title_arrow.png"/>
            <span>个人基本信息</span>
          </div>
          <div class="personal-auth-info">
            <el-form :model="personalRuleForm" :rules="personalRules" ref="personalRuleForm" label-width="100px" class="ruleForm">
              <el-form-item label="认证方式选择：" prop="titles">
                <span class="personal-auth-title">人脸识别认证</span>
              </el-form-item>
              <el-form-item label="姓名：" prop="name">
                <el-input placeholder="请输入姓名" v-model="personalRuleForm.name"></el-input>
              </el-form-item>
              <el-form-item label="身份证号码："  prop="idCard">
                <el-input placeholder="请输入身份证号码" v-model="personalRuleForm.idCard"></el-input>
              </el-form-item>
              <el-form-item label="" prop="personalChecked" class="check-item">
                <el-checkbox class="personal-info-checked-con" v-model="personalRuleForm.personalChecked"></el-checkbox><span class="personal-info-checked-text">同意将以上信息用于平台的实名认证</span>
              </el-form-item>
            </el-form>
            <button class="personal-auth-but" type="botton" :disabled="personalRuleClick" @click="personalRuleFormSub">下一步</button>
          </div>
        </div>
        <!-- 人脸识别 -->
        <div class="face-sign-con" v-if="stepCur == 2">
          <div class="auth-title">
            <img alt="" src="../../assets/images/enterpriseAuth/title_arrow.png"/>
            <span>个人基本信息</span>
          </div>
          <div class="face-sign-info">
            <div class="face-sign-info-con">
              <p class="face-title">
                <img src="../../assets/images/enterpriseAuth/desc.png"/>请使用微信或其他软件扫描二维码完成人脸识别认证，也可以通过下载真相取证APP完成个人实名
              </p>
              <div class="rlsb">
                <p class="rlsb_title" ><span></span>&nbsp;二维码5分钟内有效&nbsp;<span></span> </p> 
                <div class="erweima" v-show="codeStatus!=0 && !error_num">
                    <vue-qr  colorDark="#000" :text="erweimaUrl" :size="200"></vue-qr> 
                </div>
                <div class="erweima_errro" v-show="error_erweima && codeStatus!=0">
                    <p class="error_title">二维码失效</p>
                    <span class="update_erweima" @click="updateEr(1)">点击刷新</span>
                </div>
                <div class="erweima_errro" style="width: 270px;margin-left: -135px;" v-show="error_num">
                    <p class="error_title">{{text}}</p>
                </div>
                <div class="erweima_success" v-show="(status==1||status==2) && codeStatus!=0">
                    <img src="../../assets/images/enterpriseAuth/wxsmcg_icon.png" alt="" style="display:inline-block;margin-bottom:8px;"/>
                    <p class="success_title">扫描成功</p>
                    <p class="success_desc">请在手机端刷脸认证</p>
                    <span class="success_update_erweima" @click="updateEr(1)">点击刷新</span>
                </div>
                <div class="erweima_success" v-show="codeStatus==0">
                    <img src="../../assets/images/enterpriseAuth/wxsmcg_icon.png" alt="" style="display:inline-block;margin-bottom:8px;"/>
                    <p class="success_title">人脸认证成功</p>
                    <p class="success_desc">请点击已完成人脸验证</p>
                </div>
              </div>
              <button class="face-sign-but" type="botton" v-if="status==2" @click="getFaceResult">已完成人脸验证</button>
              <button class="face-sign-but no-click" type="botton" v-else>已完成人脸验证</button>
            </div>
          </div>
        </div>
        <!-- 机构信息 -->
        <div class="enterprise-auth" v-if="stepCur == 3">
          <div class="auth-title">
            <img alt="" src="../../assets/images/enterpriseAuth/title_arrow.png"/>
            <span>个人基本信息<span class="cur-auth-title"> - 填写机构信息</span></span>
          </div>
          <div class="enterprise-auth-info">
            <div class="enterprise-auth-info-con">
              <p class="enterprise-auth-title">基本信息 （*为必填项）</p>
              <el-form :model="enterpriseRuleForm" :rules="enterpriseRules" ref="enterpriseRuleForms" label-width="100px" class="ruleForm">
                <el-form-item label="机构全称："  prop="enterpriseName">
                  <el-input placeholder="请输入机构全称" v-model="enterpriseRuleForm.enterpriseName"></el-input>
                </el-form-item>
                <el-form-item label="所属行业：" prop="enterpriseIndustryId">
                  <el-select v-model="enterpriseRuleForm.enterpriseIndustryId" placeholder="请选择使用的平台">
                    <el-option :label="item.name" :value="item.id"  v-for="item in INDUSTRY_TYPE"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="机构类型：" prop="enterpriseCategoryId">
                  <el-select v-model="enterpriseRuleForm.enterpriseCategoryId" placeholder="请选择使用的平台">
                    <el-option :label="item.name" :value="item.id"  v-for="item in INSTITUTION_TYPE"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="机构证件号码："  prop="organizationCode">
                  <el-input placeholder="请输入营业执照上的统一社会信用代码" v-model="enterpriseRuleForm.organizationCode"></el-input>
                </el-form-item>
                <el-form-item label="机构地址："  prop="enterpriseAddress" class="enterpriseAddress">
                  <CitySelect @addressArea="addressArea" :setAddress="setAddress" v-model="enterpriseRuleForm.enterpriseAddress"></CitySelect>
                </el-form-item>
                <el-form-item label=""  prop="enterpriseAddressInfo" class="address-info">
                  <el-input placeholder="请输入详细地址" v-model="enterpriseRuleForm.enterpriseAddressInfo"></el-input>
                </el-form-item>
                <el-form-item label="邮政编码："  prop="enterprisePostCode" class="label-padLeft">
                  <el-input placeholder="请输入邮政编码" v-model="enterpriseRuleForm.enterprisePostCode"></el-input>
                </el-form-item>
                <el-form-item label="固定电话："  prop="enterprisePhone" class="label-padLeft">
                  <el-input placeholder="请输入固定电话" v-model="enterpriseRuleForm.enterprisePhone"></el-input>
                </el-form-item>
                <el-form-item label="传真电话："  prop="enterpriseFax" class="label-padLeft">
                  <el-input placeholder="请输入传真电话" v-model="enterpriseRuleForm.enterpriseFax"></el-input>
                </el-form-item>
              </el-form>
            </div>
            <div class="enterprise-auth-info-desc">
              <p class="enterprise-auth-title">温馨提示：</p>
              <ul>
                <li>1、请提供最新的三证合一的营业执照，确保营业执照上的机构信息和国家企业信用信息公示系统公布的信息一致。</li>
                <li>2、确保证件信息清晰可辨别，营业执照二维码可扫出机构信息（为确保证件信息清晰，建议上传高清原图） </li>
                <li>3、授权书必须加盖机构公章，附个人身份证正反面照片； </li>
                <li>4、上传的认证材料必须真实有效，若发现存在问题一律不予通过； </li>
                <li>5、机构认证成功后，将代表机构账号主体进行业务操作； </li>
                <li>  6、审核周期为3～15个工作日； </li>
                <li>7、若发生组织机构变更，请联系客服处理400-8650-010； </li>
              </ul>
            </div>
          </div>
          <!-- 上传文件 -->
          <div class="upload-con">
            <p class="enterprise-auth-title">证件上传 （全部必填）<span>原件扫描上传，图片大小不超过2M，文件格式为jpg、jpeg、png。如需提交更多证件，请在“其他证件”上传处上传。</span></p>
            <div class="upload-con-info">
              <div class="upload-con-info-item">
                  <p class="upload-con-info-title"><span>*</span>营业执照</p>
                  <div class="business-license" id="business-license1">
                      <img class="upload-icon" src="../../assets/images/enterpriseAuth/upload_icon.png" v-show="!enterpriseRuleForm.licensePath"/>
                      <img id="business-license1-src" :src="enterpriseRuleForm.licensePath" v-show="enterpriseRuleForm.licensePath"/>
                      <input type="file" id="business-license1-up" @change="uploaderImg($event,'business-license1')" />
                      <label for="business-license1-up"></label>
                  </div>
                  <span class="error-tip">{{ tip.licensePath }}</span>
              </div>
              <div class="upload-con-info-item">
                <p class="upload-con-info-title"><span>*</span>授权委托书<a :href="`${publicPath}${downloadhref}`" target="_blank" download class="down-temp" >模版下载</a></p>
                <div class="business-license" id="business-license2">
                  <img class="upload-icon" src="../../assets/images/enterpriseAuth/upload_icon.png" v-show="!enterpriseRuleForm.powerOfAttorneyPath"/>
                  <img id="business-license2-src" :src="enterpriseRuleForm.powerOfAttorneyPath" v-show="enterpriseRuleForm.powerOfAttorneyPath"/>
                  <input type="file" id="business-license2-up" @change="uploaderImg($event,'business-license2')"/>
                      <label for="business-license2-up"></label>
                </div>
                <span class="error-tip">{{ tip.powerOfAttorneyPath }}</span>
              </div>
              <div class="upload-con-info-item">
                <p class="upload-con-info-title">其他证件</p>
                <div class="business-license" id="business-license3">
                  <img class="upload-icon" src="../../assets/images/enterpriseAuth/upload_icon.png" v-show="!enterpriseRuleForm.otherPath"/>
                  <img id="business-license3-src" :src="enterpriseRuleForm.otherPath" v-show="enterpriseRuleForm.otherPath"/>
                  <input type="file" id="business-license3-up" @change="uploaderImg($event,'business-license3')"/>
                  <label for="business-license3-up"></label>
                </div>
                <span class="error-tip">{{ tip.otherPath }}</span>
              </div>
            </div>
            <div class="enterprise-checked">
              <el-checkbox class="enterprise-info-checked-con" v-model="enterpriseRuleForm.checked" @change="enterpriseChecked"></el-checkbox><span class="login-info-checked-text">我已阅读并同意</span><span class="login-info-checked" @click="goAgreement">《legalXchain司法联盟链用户注册协议》</span>
              <span class="error-msg">{{tip.checked}}</span>
            </div>
            <div class="upload-btns">
              <!-- <button type="button" @click="enterpriseSub">上一步</button> -->
              <button type="button" :disabled="isNextStep" @click="enterpriseSub">{{ enterpriseSubText }}</button>
            </div>
          </div>
        </div>
        <!-- 审核结果 -->
        <div class="result-auth-con" v-if="stepCur == 4">
          <div class="auth-title">
            <img alt="" src="../../assets/images/enterpriseAuth/title_arrow.png"/>
            <span>个人基本信息 - 填写机构信息 <span class="cur-auth-title">- 审核结果</span></span>
          </div>
          <div class="result-con-info">
              <div class="result-con-info-success" v-if="enterpriseAuthStatus ==0">
                  <img src="../../assets/images/enterpriseAuth/submit_end.png" alt=""/>
                  <p>信息已提交成功</p>
                  <span>请耐心等待，我们将在1个工作日完成审核！</span>
              </div>  
              <div class="result-con-info-success" v-if="enterpriseAuthStatus ==1">
                  <img src="../../assets/images/enterpriseAuth/submit_success.png" alt=""/>
                  <p>审核通过</p>
              </div> 
              <div class="result-con-info-success" style="width: 585px;" v-if="enterpriseAuthStatus ==3">
                  <img src="../../assets/images/enterpriseAuth/error.png" alt="" style=""/>
                  <p>您的申请审核不通过，请详细检查您所提交的资料是否合规再重新提审！</p>
                  <button type="button" class="again-authentication" @click="againAuthentication">重新认证</button>
              </div> 
          </div>
        </div>
    </div>
  </div>
  <!-- 企业人脸识别弹窗 -->
  <el-dialog
    title="人脸识别"
    :visible.sync="faceModel"
    width="30%"
    :append-to-body="true"
    :close-on-click-modal="false"
    @close="faceModelClose"
    center>
    <div class="rlsb-enterprise">
      <p class="rlsb_title" ><span></span>&nbsp;二维码5分钟内有效&nbsp;<span></span> </p> 
      <div class="erweima" v-show="codeStatus!=0 && !error_num">
          <vue-qr  colorDark="#000" :text="erweimaUrl" :size="200"></vue-qr> 
      </div>
      <div class="erweima_errro" v-show="error_erweima && codeStatus!=0">
          <p class="error_title">二维码失效</p>
          <span class="update_erweima" @click="updateEr(2)">点击刷新</span>
      </div>
      <div class="erweima_errro" style="width: 270px;margin-left: -135px;" v-show="error_num">
          <p class="error_title">{{text}}</p>
      </div>
      <div class="erweima_success" v-show="(status==1||status==2) && codeStatus!=0">
          <img src="../../assets/images/enterpriseAuth/wxsmcg_icon.png" alt="" style="display:inline-block;margin-bottom:8px;"/>
          <p class="success_title">扫描成功</p>
          <p class="success_desc">请在手机端刷脸认证</p>
          <span class="success_update_erweima" @click="updateEr(2)">点击刷新</span>
      </div>
      <div class="erweima_success" v-show="codeStatus==0">
          <img src="../../assets/images/enterpriseAuth/wxsmcg_icon.png" alt="" style="display:inline-block;margin-bottom:8px;"/>
          <p class="success_title">人脸认证成功</p>
          <p class="success_desc">请点击已完成人脸验证</p>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <!-- <el-button @click="centerDialogVisible = false">取 消</el-button> -->
      <el-button v-if="status==2" type="primary" @click="enterpriseFaceResult">已完成人脸验证</el-button>
      <el-button class="no-click-face-Btn" v-else type="primary">已完成人脸验证</el-button>
    </span>
  </el-dialog>
  </div>
</template>

<script>
// 正则验证
import {verificationpName,verificationpIdCard,regexBusinessLicense, regexFixedTele,regexFaxTele,regexPostCode} from "@/utils/validate";
// 登录页面
import Login from './login';
// 二维码组件
import vueQr from "vue-qr";
//选择地址三级联动组件
import CitySelect from "../common/CitySelect";
// 部分正则
import Ordinary from '../../lib/const';
//人脸识别信息加密
import CryptoJSFn from '../../lib/secret';
export default {
  data() {
    //姓名
    const name = (rule, value, callback) => {
      if (value && value !='') {
        if (!verificationpName(value)) {
          callback(new Error("格式不正确"));
        } else {
          callback();
        }
      } else {
        callback(new Error("请输入姓名"));
      }
    };
    //身份证号
    const idCard = (rule, value, callback) => {
      if (value && value !='') {
        if (!verificationpIdCard(value)) {
          callback(new Error("格式不正确"));
        } else {
          callback();
        }
      } else {
        callback(new Error("请输入身份证号"));
      }
    };
    //个人信息勾选
    const personalChecked=(rule, value, callback)=>{
      console.log(value,'value')
      if (value) {
        callback();
      } else {
        callback(new Error("请同意将以上信息用于平台的实名认证"));
      }
    }
    //个人信息title
    const titles= (rule, value, callback)=>{
      callback();
    }
    // 企业地址
    const enterpriseAddress=(rule, value, callback)=>{
      if(this.addressInfo.provinceName ==''){
        callback(new Error("请选择省份"));
      }else if(this.addressInfo.cityName ==''){
        callback(new Error("请选择城市"));
      }else if(this.addressInfo.areaName == ''){
        callback(new Error("请选择地区"));
      }else{
        callback();
      }
    }
    //企业姓名
    const enterpriseName=(rule, value, callback)=>{
      if(value !=''){
        if(value.length <4 || value.length >50){
          callback(new Error('机构全称不能少于4字，高于50字'));
        }else{
          callback();
        }
      }else{
        callback(new Error('不能为空'));
      }
    }
    //企业证件号码：
    const organizationCode=(rule, value, callback)=>{
      if(value !=''){
        if(regexBusinessLicense(value)){
          callback()
        }else{
          callback(new Error('格式不正确'));
        }
      }else{
        callback(new Error('不能为空'));
      }
    }
    //固定电话
    const enterprisePhone=(rule, value, callback)=>{
      if(value !=''){
        if(regexFixedTele(value)){
          callback()
        }else{
          callback(new Error('格式不正确，请参考：010-88888888'));
        }
      }else{
        callback()
      }
    }
    //传真电话
    const enterpriseFax=(rule, value, callback)=>{
      if(value !=''){
        if(regexFaxTele(value)){
          callback()
        }else{
          callback(new Error('格式不正确'));
        }
      }else{
        callback()
      }
    }
    //邮政编码
    const enterprisePostCode=(rule, value, callback)=>{
      if(value !=''){
        if(regexPostCode(value)){
          callback()
        }else{
          callback(new Error('格式不正确'));
        }
      }else{
        callback()
      }
    }
    //企业详细地址
    const enterpriseAddressInfo=(rule, value, callback)=>{
      if(value !=''){
        if(value.length >200){
          callback(new Error('地址长度不能超过200个字'));
        }else{
          callback();
        }
      }else{
        callback(new Error('不能为空'));
      }
    }
    const enterpriseIndustryId=(rule, value, callback)=>{
      if(value !=''){
        callback()
      }else{
        callback(new Error('不能为空'));
      }
    }
    const enterpriseCategoryId=(rule, value, callback)=>{
      if(value !=''){
        callback()
      }else{
        callback(new Error('不能为空'));
      }
    }
    return {
      stepCur:1,//步骤进度
    //个人信息 start
      personalRuleForm: {
        name: "",//姓名
        idCard: "",//身份证号
        title:"1",
        personalChecked:""//勾选框
      },
      personalRules: {
        name: [
          {
            required: true,
            validator: name,
            trigger: "blur"
          }
        ],
        idCard: [
          {
            required: true,
            trigger: "blur",
            validator: idCard,
          }
        ],
        titles: [
          {
            required: true,
            validator: titles,
            trigger: "blur",
          }
        ],
        personalChecked: [
          {
            required: true,
            validator: personalChecked,
            trigger: "change",
          }
        ]
      },
    //个人信息 end
    //人脸识别 start
      erweimaUrl:"", //二维码信息
      sureClick:false,
      success_erweima:false, //二维码扫描成功
      error_erweima:false,//二维码失效
      error_num:"",
      orderNo:"",//订单号
      status:0,//二维码状态
      codeStatus:null,//认证状态
      text:"",
      timers:null,
    //人脸识别 end
    //机构信息 start
      enterpriseRuleForm:{
        organizationCode:"",//企业证件号码：
        enterpriseName: '', // 机构名称
        enterpriseAddress:"",//企业地址
        enterpriseAddressInfo:"",//详细地址
        enterpriseIndustryId:1, // 行业
        enterpriseCategoryId:1, // 机构类型
        enterprisePhone: '', // 固定电话
        enterpriseFax: '', // 传真电话
        enterprisePostCode: '', // 邮政编码
        licensePath: '', // 营业执照注册号 || 许可证书 || 法人证书路径
        powerOfAttorneyPath: '', // 委托书路径
        otherPath: '', // 其他资料路径
        checked:"",//同意注册协议
      },
      INDUSTRY_TYPE: Ordinary.INDUSTRY_TYPE,
      INSTITUTION_TYPE: Ordinary.INSTITUTION_TYPE,
      // 提示语
      tip:{
        checked:"",//同意注册协议
        licensePath: '', // 营业执照注册号 || 许可证书 || 法人证书路径
        powerOfAttorneyPath: '', // 委托书路径
        otherPath: '', // 其他资料路径
      },
      //三级联动地址选择器
      addressInfo:{
        provinceName:"",//省
        cityName:"",//市
        areaName:""//县/区
      },
      //设置回显地址
      setAddress:{
        province: '',//省
        city: '',//市
        district: ''//县/区
      },
      enterpriseRules:{
        enterpriseAddress:[
          {
            required: true,
            validator: enterpriseAddress,
            trigger: "change",
          }
        ],
        enterpriseName:[
          {
            required: true,
            validator: enterpriseName,
            trigger: "blur",
          }
        ],
        enterpriseIndustryId:[
          {
            required: true,
            validator: enterpriseIndustryId,
            trigger: "change",
          }
        ],
        enterpriseCategoryId:[
          {
            required: true,
            validator: enterpriseCategoryId,
            trigger: "change",
          }
        ],
        organizationCode:[
          {
            required: true,
            validator: organizationCode,
            trigger: "blur",
          }
        ],
        enterpriseFax:[
          {
            required: false,
            validator: enterpriseFax,
            trigger: "blur",
          }
        ],
        enterprisePhone:[
          {
            required: false,
            validator: enterprisePhone,
            trigger: "blur",
          }
        ],
        enterprisePostCode:[{
            required: false,
            validator: enterprisePostCode,
            trigger: "blur",
        }],
        enterpriseAddressInfo:[{
          required: true,
          validator: enterpriseAddressInfo,
          trigger: "blur",
        }]
      },
      //上传图片
      uploaderObj:{},
      //企业人脸识别
      faceModel:false,
    //机构信息 end
      islogin:true,
      //登录的账号信息
      userInfo:'',
      personalRuleClick:false,
      enterpriseAuthStatus:'',
      publicPath: process.env.BASE_URL,
      downloadhref:"template/实名认证授权委托书.pdf",
      enterpriseSubText:'下一步',
      isNextStep:false
    };
  },
  components:{Login,vueQr,CitySelect},
  computed: {
    lanInfo() {
      return this.$store.getters.getLanInfo.ContactUs;
    },
    lanType() {
      return this.$store.getters.getLanType;
    }
  },
  mounted() {},
  methods: {
    // 上传图片
    uploaderImg (event,id) {
      let file=event.target.files[0];
      let that = this;
      let IdObj = {
        'business-license1': 'licensePath',
        'business-license2': 'powerOfAttorneyPath',
        'business-license3': 'otherPath',
      };
      let params={
        sizeLimit:2097152,
        extensions: ['image/jpg','image/jpeg','image/png'],
      };
      if(!file){
        return;
      }
      if (params.extensions.indexOf(file.type) ==-1 ) {
        that.tip[IdObj[id]] = '您所选的文件格式不正确';
        return false;
      }
      if (file.size > params.sizeLimit) {
        that.tip[IdObj[id]] =  '您所选的文件大小超过' + params.sizeLimit / 1024 / 1024 + 'M';
        return false;
      }
      if (file.size == 0) {
        that.tip[IdObj[id]] =  '不支持0KB文件上传';
        return false;
      }
      that.tip[IdObj[id]] =  '';
      let files = new FileReader();
      files.readAsDataURL(file);
      files.onload = function(){
        that.enterpriseRuleForm[IdObj[id]] = files.result;
        that.tip[IdObj[id]] = '';
        document.getElementById(id + '-src').src = files.result;
      }
    },
    enterpriseChecked(){
      if(this.enterpriseRuleForm.checked){
        this.tip.checked='';
      }
    },
    //基本信息第一步
    personalRuleFormSub(){
      if(this.personalRuleClick){
        return;
      }
      this.$refs.personalRuleForm.validate(valid => {
        if (valid) {
          this.personalRuleClick=true
          this.getFaceAuthOrderNo(1);
        }else{
          this.personalRuleClick=false
        }
      })
    },
    //跳转隐私协议
    goAgreement(){
      let openWin = window.open('_blank','agreement');
      let str=this.$route.path.substr(1,2);
      openWin.location='/'+str+'/agreement'
    },
    //点击登录回调
    loginNext(data){
      console.log(data)
      this.islogin=false;
      this.userInfo=data;
      // sessionStorage.setItem('legalUserInfo',JSON.stringify(data));
      //个人实名成功
      this.setDataInfo(data);
    },
    //设置实名回显数据
    setDataInfo(data){
      if(data.userRealNameInfo && data.userRealNameInfo.authStatus == 2){
        //企业实名成功
        if(data.enterpriseAuthStatus && data.enterpriseAuthStatus.status == 2){
          this.enterpriseAuthStatus=1;
          this.stepCur=4;
        }else if(data.enterpriseAuthStatus && data.enterpriseAuthStatus.status == 1){
          this.enterpriseAuthStatus=0;
          //企业实名审批中
          this.stepCur=4;
        }else{
          if(data.enterpriseAuthStatus && data.enterpriseAuthStatus.status == 1){
            this.enterpriseAuthStatus=3;
            //企业实名审批失败
            this.stepCur=4;
          }else{
            this.stepCur=3;
          }
          //处理企业回显数据
          let o=data.enterpriseAuthStatus;
          if(o){
            this.setAddress.province = o.provinceName;
            this.setAddress.city = o.cityName;
            this.setAddress.district = o.areaName;
            this.addressInfo.provinceName = o.provinceName // 一级 省
            this.addressInfo.cityName = o.cityName // 二级 市
            this.addressInfo.areaName =o.areaName // 三级 区
            this.enterpriseRuleForm.enterpriseAddressInfo=o.enterpriseAddress?o.enterpriseAddress:'';
            this.enterpriseRuleForm.enterpriseFax=o.enterpriseFax?o.enterpriseFax:'';
            this.enterpriseRuleForm.enterprisePhone=o.enterprisePhone?o.enterprisePhone:'';
            this.licensePath=o.licenseOssPath?o.licenseOssPath:'';
            this.powerOfAttorneyPath=o.powerOfAttorneyOssPath?o.powerOfAttorneyOssPath:'';
            this.enterpriseRuleForm.enterprisePostCode=o.enterprisePostCode?o.enterprisePostCode:'';
            this.enterpriseRuleForm.enterpriseCategoryId=o.enterpriseCategoryId ?o.enterpriseCategoryId:1;
            this.enterpriseRuleForm.enterpriseIndustryId=o.enterpriseIndustryId ?o.enterpriseIndustryId:1;
            this.enterpriseRuleForm.organizationCode=o.license?o.license:'';
            this.enterpriseRuleForm.enterpriseName=o.enterpriseName?o.enterpriseName:'';
            this.otherPath=o.organizationCodeOssPath?o.organizationCodeOssPath:''
          }
          if(data.userRealNameInfo){
            this.personalRuleForm.idCard=data.userRealNameInfo.idcardNumber;
            this.personalRuleForm.name=data.userRealNameInfo.realName;
          }
        }
      }else{
        //个人实名未通过
        this.stepCur=1;
        //处理个人回显数据
        if(data.userRealNameInfo){
          this.personalRuleForm.idCard=data.userRealNameInfo.idcardNumber;
          this.personalRuleForm.name=data.userRealNameInfo.realName;
        }
      }
    },
    //重新认证
    againAuthentication(){
      this.stepCur=3;
    },
    //点击已完成人脸验证
    getFaceResult(){
      this.stepCur=3;
    },
    // 更新省市区
    addressArea (addressArea) {
      this.addressInfo.provinceName = addressArea.cityText.provinceText // 一级 省
      this.addressInfo.cityName = addressArea.cityText.cityText // 二级 市
      this.addressInfo.areaName = addressArea.cityText.districtText // 三级 区
    },
    //机构信息-上一步按钮
    backFn(){
      this.stepCur=1;
    },
    //处理时间格式年/月/日
    getTimeFun(){
      var d=new Date();
      var ye = d.getFullYear();
      var mo = (d.getMonth()+1).toString().padStart(2,'0');
      var da = d.getDate().toString().padStart(2,'0');
      var time = ye+'/'+mo+'/'+da;
      return time;
    },
    //机构信息-下一步按钮
    enterpriseSub(){
      this.$refs.enterpriseRuleForms.validate(valid => {
        if (valid) {
          let o=this.enterpriseRuleForm;
          if(o.licensePath ==''){
            this.tip.licensePath="请上传营业执照"
            return;
          }else if(o.powerOfAttorneyPath == ''){
            this.tip.powerOfAttorneyPath="请上传授权委托书"
            return;
          }
          if(!this.enterpriseRuleForm.checked){
            this.tip.checked='请同意《legalXchain司法联盟链用户注册协议》';
            return;
          }
          this.isNextStep=true;
          this.enterpriseSubText='loading...';
          // this.getFaceAuthOrderNo(2);
          this.enterpriseFaceResult();
          // this.faceModel=true;
        }
      })
    },
    //企业活体弹框关闭回调
    faceModelClose(){
      clearTimeout(this.timers); //清理定时任务
    },
    //企业活体认证结果
    enterpriseFaceResult(){
      this.faceModel=false;
      let o=this.enterpriseRuleForm;
      let licensePath=o.licensePath.replace(/^data:image\/\w+;base64,/, "");
      let powerOfAttorneyPath=o.powerOfAttorneyPath.replace(/^data:image\/\w+;base64,/, "");
      let otherPath=o.otherPath.replace(/^data:image\/\w+;base64,/, "");
      let params={
        userId:this.userInfo.loginResult.userId,
        enterpriseName:o.enterpriseName,
        enterpriseIndustryId:o.enterpriseIndustryId,
        enterpriseCategoryId:o.enterpriseCategoryId,
        enterpriseAddress:o.enterpriseAddressInfo,
        provinceName: this.addressInfo.provinceName,
        cityName:this.addressInfo.cityName,
        areaName:this.addressInfo.areaName,
        license:o.organizationCode,
        enterprisePostCode:o.enterprisePostCode,
        licenseBase64:licensePath,
        powerOfAttorneyBase64:powerOfAttorneyPath,
        organizationCodeBase64:otherPath,
        enterpriseFax:o.enterpriseFax,
        enterprisePhone:o.enterprisePhone
      }
      
      this.$ajax
        .post("/webapi/user/enterpriseAuthentication",params)
        .then(res => {
          if (res.data.code == 427) {
            this.stepCur=4;
            // this.$emit('nextSub',res.data.extraData)
          }else{
            this.loginMsg=res.data.message;
            this.isNextStep=false;
            this.enterpriseSubText="下一步"
          }
        }); 
    },
    //获取订单号 type-1个人 2-企业
    getFaceAuthOrderNo(type){
      let times=this.getTimeFun();
      let name=CryptoJSFn.Encrypt(`${times}${this.personalRuleForm.name}`);//姓名加密
      let idcardNumber=CryptoJSFn.Encrypt(`${times}${this.personalRuleForm.idCard}`);//身份证号加密
      var timer=null;
      //获取二维码地址
       clearInterval(timer)
       this.$ajax({
          url:"/webapi/user/getFaceOrderNo",
          method: 'GET',
          params:{
            userId: this.userInfo.loginResult.userId,
            liveType:type // 1-实名;2-活体
          }
        }).then( data  =>{
          let datas=data.data
        if(datas.code==200){
          var endTime = new Date().getTime()+5*60*1000;
          this.orderNo=datas.extraData.orderNo;//data.data.url
          if(datas.extraData.orderNo!=-1){
            this.setTimerEr();
            this.erweimaUrl=this.$GlobalConfig.faceUrl+"/ip360_mobile/activities/perStartFace.html?orderNo="+datas.extraData.orderNo+"&uid="+this.userInfo.loginResult.userId+"&name="+name+'&idcardNumber='+idcardNumber+'&partnerId='+this.userInfo.partnerId;
            if(type ==1){
              this.stepCur = 2;
            } else{
              this.stepCur = 3;
            }
            timer=setInterval(()=>{
              var start =  new Date().getTime();
              if(start > endTime){
                this.error_erweima=true;
                this.status=0;
                clearInterval(timer);
              }else{
                if(this.status==1||this.status==2){
                  clearInterval(timer);
                  this.error_erweima=false;
                }else{
                  this.error_erweima=false;
                }
              }
            },1000);
            if(this.status==1||this.status==2){
              clearInterval(timer);
              this.error_erweima=false;
            }
          }else{
            this.text="人脸识别服务异常，请联系管理员！"
            this.error_num=true;
            this.status=0;
            this.error_erweima=false;
          }
        }else{
          this.error_erweima=true;
          this.status=0;
          this.personalRuleClick=false;
        }
      });
    },
    //更新二维码
    updateEr(type){
      if(this.codeStatus==0){
        return;
      }else{
        this.error_erweima=false;
        this.getFaceAuthOrderNo(type);
      }
    },
    //实时获取二维码状态
    setTimerEr() {
      this.timers=null;
      let orderNos=this.orderNo;
      var obj={orderNo:orderNos};
      this.$ajax({
          url:"/webapi/user/getFaceAuthStatus",
          method: 'GET',
          params:{
            orderNo:orderNos
          }
        }).then(data=>{
        let datas=data.data;
        if(datas.code==200){
          clearTimeout(this.timers);
          this.status=datas.extraData.status;
          this.codeStatus=datas.extraData.authStauts;
          let self=this;
          if (self && !self._isDestroyed) {
            this.timers = setTimeout(() => {
                this.setTimerEr();
            }, 2000);
          }
          if(obj.orderNo!=this.orderNo){
            clearTimeout(this.timers);
          }
          //二维码失效
          else if(this.error_erweima){
            clearTimeout(this.timers);
          }
          //成功
          else if(datas.extraData.authStauts==0){
            clearTimeout(this.timers);
          }
          //失败0-成功，-1未完成，其余都是失败。
          else if(datas.extraData.authStauts!=0 && datas.extraData.authStauts!=-1){
            clearTimeout(this.timers);
          }
        }
        else {
          clearTimeout(this.timers); //清理定时任务
        }
      })
    },
  },
  watch: {
    showPic1(val) {
      if (val) {
        let index = 2;
        let interval = setInterval(() => {
          this["showPic" + index++] = true;
          if (index == 7) {
            clearInterval(interval);
          }
        }, 800);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.enterprise-con{
  width:100%;
  height:100%;
  background: #F7F9FB;
  padding-bottom: 20px;
  .auth-title{
      width:100%;
      border-bottom: 1px solid #E5E5E5;
      height:55px;
      font-size: 18px;
      display: flex;
      align-items: center;
      color: #323232;
      img{
        margin-right: 10px;
      }
      .cur-auth-title{
        color: #2A51F2;
      }
    }
}
  .content {
    width: 1200px;
    overflow: hidden;
    margin: 0 auto;
    border:1px solid #E4E8EB;
    background: #fff;
    margin-top: 20px;
  }
  .enterprise-step{
    width: 100%;
    padding: 0px 36px;
    // 步骤条
    .step-line{
      width: 735px;
      margin:40px auto;
      img{
        width: 735px;
      }
      .step-line-text{
        width: 100%;
        margin-top:5px;
        span{
          display: inline-block;
          width:183px;
          text-align:Center;
          color: #989898;
          font-size: 14px;
        }
      }
    }
    .personal-auth,.face-sign-con,.enterprise-auth,.result-auth-con{
      width: 1106px;
      overflow: hidden;
      padding: 0px 30px;
      margin:42px auto;
      border:1px solid #E4E8EB;
      box-sizing: border-box;
    }
    // 个人信息
    .personal-auth{
      .personal-info-checked-text{
        font-size: 14px;
        color: #646464;
        padding-left: 10px;
      } 
      .personal-info-checked-con{
        margin-left: 20px;
      }
      .personal-auth-info{
        width: 460px;
        margin:0 auto;
        margin-top: 84px;
        margin-bottom: 106px;
        .personal-auth-title{
          color:#646464;
        }
      }
      .personal-auth-but{
        width: 340px;
        height: 36px;
        background: #2A51F2;
        border-radius: 4px;
        color: #fff;
        font-size: 14px;
        display: block;
        margin:20px 0px 48px 120px;
      }
    }
    //人脸识别
    .face-sign-info{
      width: 1016px;
      margin:48px auto;
      .face-sign-info-con{
        .face-title{
          width: 100%;
          height:40px;
          background: #F2F6FA;
          text-align: center;
          font-size: 14px;
          line-height: 40px;
          color: #646464;
          margin: 0 auto;
          margin-top: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          img{
            width: 20px;
            height: 20px;
            margin-right: 10px;
          }
        }
        .rlsb{
          width: 100%;
          height: 200px;
          position: relative;
          .erweima_errro{
            width:160px;
            height:160px;
            background:rgba(255,255,255,0.78);
            position: absolute;
            top: 38px;
            left: 50%;
            margin-left:-80px;
            z-index: 99;
            text-align: center;
            padding-top: 60px;
            box-sizing: border-box;
            .error_title{
              font-size:16px;
              font-family:PingFangSC-Medium,PingFang SC;
              font-weight:600;
              color:rgba(50,50,50,1);
              margin-bottom: 12px;
            }
            .update_erweima{
              font-size:14px;
              font-family:PingFangSC-Regular,PingFang SC;
              font-weight:400;
              color:#000;
              cursor: pointer;
            }
          }
          .erweima_success{
            width:160px;
            height:160px;
            background:rgba(255,255,255,0.88);
            position: absolute;
            top: 30px;
            left: 50%;
            margin-left:-80px;
            z-index: 99;
            text-align: center;
            padding-top: 35px;
            box-sizing: border-box;
            .success_desc{
              margin-bottom: 10px;
              margin-top: 3px;
              font-size: 13px;
            }
            .success_title{
              font-size:16px;
              font-family:PingFangSC-Medium,PingFang SC;
              font-weight:600;
              color:rgba(50,50,50,1);
              margin-top: -15px !important;
            }
            .success_update_erweima{
              font-size:14px;
              font-family:PingFangSC-Semibold,PingFang SC;
              font-weight:600;
              color:rgba(77,175,247,1);
              cursor: pointer;
            }
            img{
              opacity: 1;
            }
          }
          .rlsb_title{
            color: #646464;
            margin: 20px 0;
            display: flex;
            align-items: center;
            justify-content: center;
            // span{
            //   display: inline-block;
            //   width: 8px;
            //   height: 1px;
            //   background: #1890FF;
            //   border:0;
            // }
          }
          .erweima{
            width: 160px;
            margin: 0 auto;
            height: 160px;
            img{
              width: 100%;
            }
          }
          .rlsb_desc{
            width: 100%;
            text-align: center;
            height: 40px;
            line-height: 40px;
            margin-top: 20px;
          }
        }
      }
      .face-sign-but{
        width: 162px;
        height: 36px;
        background: #2A51F2;
        border-radius: 4px;
        color: #fff;
        font-size: 14px;
        display: block;
        margin: 20px auto 48px auto;
      }
      .no-click{
        background: #d3d0d0;
        cursor: no-drop;
      }
    }
    //机构信息
    .enterprise-auth-info{
      width: 100%;
      display: flex;
      justify-content: space-between;
      .enterprise-auth-title{
        font-size: 16px;
        font-weight: 400;
        color: #2A51F2;
        padding: 35px 0px 20px 0px;
      }
      .enterprise-auth-info-con{
        width: 100%;
      }
      .enterprise-auth-info-desc{
        width: 310px;
        flex-shrink: 0;
        ul{
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #989898;
          li{
            line-height: 24px;
          }
        }
      }
    }
    //上传文件
    .upload-con{
      .enterprise-auth-title{
        font-size: 16px;
        font-weight: 400;
        color: #2A51F2;
        padding: 35px 0px 20px 0px;
        span{
          font-size: 14px;
          font-weight: 400;
          color: #646464;
          padding-left: 20px;
        }
      }
      .login-info-checked-text{
        font-size: 14px;
        color: #646464;
        padding-left: 10px;
      }
      .login-info-checked{
        font-size: 14px;
        color: #2A51F2;
        cursor: pointer;
      } 
      .error-msg{
        font-size: 12px;
        color: #F56C6C;
      }
      .upload-btns{
        margin: 24px 0px 52px 0px;
        button{
          width: 136px;
          height: 28px;
          border: 1px solid #2A51F2;
          margin-right: 20px;
          color: #fff;
          background: #2A51F2;
        }
      }
      .upload-con-info{
        width:652px;
        display: flex;
        .upload-con-info-item{
          flex-shrink: 0;
          width: 196px;
          position: relative;
          &:nth-child(1){
            margin-right: 32px;
          }
          &:nth-child(2){
            margin-right: 32px;
          }
          .upload-con-info-title{
            font-size: 14px;
            font-weight: 400;
            color: #5F5F5F;
            span:nth-child(1){
              color: #F56C6C;
              padding-right:4px;
            }
            .down-temp{
              color:#2A51F2;
              cursor: pointer;
              float: right;
            }
          }
          .business-license{
            width: 100%;
            height: 130px;
            background: #F5F5F5;
            margin:20px 0px 32px 0px;
            cursor: pointer;
            position: relative;
            input{
              position:absolute;
              top: 0;
              left:0;
              opacity: 0;
            }
            label{
              width: 100%;
              height: 100%;
              position:absolute;
              top: 0;
              left:0;
              opacity: 0;
              z-index: 2;
              cursor: pointer;
            }
            #business-license1-src,#business-license2-src,#business-license3-src{
              width: auto;
              height: 100%;
              position: absolute;
              top: 0px;
              left: 50%;
              transform: translateX(-50%);
            }
            .upload-icon{
              width: 32px;
              height: 32px;
              margin-top: 41%;
              margin-left: 50%;
              transform: translate(-50%, -100%);
            }
          }
          .error-tip{
            position: absolute;
            bottom: 13px;
            left: 0px;
            font-size: 12px;
            color: #F56C6C;
          }
        }
      }
      .enterprise-checked .error-msg{
        height: 12px;
        margin-top:3px;
      }
    }
    //审核结果
    .result-con-info{
      width: 100%;
      .result-con-info-success{
        width: 304px;
        height: 100%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        margin:200px auto;
        img{
          width: 46px;
        }
        p{
          font-size: 18px;
          padding:10px 0px 22px 0px;
        }
        span{
          font-size: 14px;
          color: rgb(100, 100, 100);
        }
      }
    }
  }
  .again-authentication{
    width: 168px;
    height: 36px;
    background: #2A51F2;
    border-radius: 4px;
    color: #fff;
    font-size: 14px;
    display: block;
    margin:30px auto;
  }
</style>
<style lang="scss">
.enterprise-step {
  .el-form-item {
    .el-input{
      width:340px;
      position: relative;
      border-radius: 0px;
      .el-input__inner{
        height: 36px;
        line-height: 36px;
      }
      .el-input-group__append{
        background-color: #fff;
        height: 24px;
        width: 111px;
        border-radius: 0px;
        border-color: #ccc;
        border: 0px;
        position: absolute;
        top: 9px;
        right: 1px;
        border-left: 1px solid #ccc;
        line-height: 24px;
        padding-top: 1px;
        text-align: center;
        cursor: pointer;
      }
    }
    .el-form-item__label{
      text-align:left;
      color:#5F5F5F;
      width:120px !important;
    }
  }
  .el-button {
    border: 1px solid #2A51F2;
    transition: all 0.7s ease-in-out 0s;
    color: #2A51F2;
  }
  .el-button:focus,
  .el-button:hover {
    color: #fff;
    background: #2A51F2;
  }
  .el-button.is-disabled,
  .el-button.is-disabled:focus,
  .el-button.is-disabled:hover {
    color: #fff !important;
    cursor: not-allowed !important;
    background-image: none;
    background-color: #8c8c8c;
    border-color: #8c8c8c;
  }

  .el-form-item.is-success .el-input__inner:focus,
  .el-form-item.is-success .el-textarea__inner:focus {
    border-color: #2A51F2;
  }
  .el-form-item.is-success .el-textarea__inner,
  .el-form-item.is-success .el-input__inner {
    border-color: #ccc;
  }
  .el-textarea__inner:focus,
  .el-input__inner:focus {
    border-color: #2A51F2;
  }
  .el-input.is-active .el-input__inner {
    border-color: #D1D1D1;
  }
  .el-input__inner,
  .el-textarea__inner {
    border-color: #D1D1D1;
    border-radius: 0px;
  }
  .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #606266 !important;
  }
  .el-checkbox__input.is-focus .el-checkbox__inner{
    border-color: #D1D1D1;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    background-color: #2A51F2 !important;
    border-color: #2A51F2 !important;
  }
  .el-input__inner::placeholder{
    color: #DCDCDC !important;
  }
  .personal-auth-info{
    .el-form-item__error{
      top: 24%;
      left: 367px;
      width: 340px;
    }
  }
  .check-item{
    height: 20px;
    .el-form-item__content{
      line-height: 20px !important;
    }
    .el-form-item__error{
      top: -3%;
      left: 284px;
      width: 340px;
    }
  }
  .label-padLeft{
    .el-form-item__label{
      padding-left: 8px !important;
    }
  }
  .enterprise-auth-info{
    .el-form-item__error{
      top: 30%;
      left: 367px;
      width: 340px;
    }
    .enterpriseAddress .el-form-item__error{
      left: 397px;
    }
  }
  .address-info{
    .el-form-item__content{
      margin-left: 120px !important;
    }
    .el-form-item__error{
      left: 348px;
    }
  }
}
</style>

